// @ts-nocheck
import React from 'react';
import EnergyOverviewCard, { ENERGY_TEXT_PRIMARY, ENERGY_TEXT_SECONDARY } from './EnergyOverviewCard.jsx';

const EnergyKpiCard = ({ label, value, suffix }) => (
  <EnergyOverviewCard>
    <h6
      style={{
        margin: 0,
        fontSize: 11,
        fontWeight: 'bold',
        letterSpacing: 1,
        textTransform: 'uppercase',
        color: ENERGY_TEXT_SECONDARY,
      }}
    >
      {label}
    </h6>
    <div style={{ display: 'flex', alignItems: 'baseline', marginTop: 10 }}>
      <span style={{ fontSize: 32, fontWeight: 'bold', color: ENERGY_TEXT_PRIMARY, lineHeight: 1 }}>{value}</span>
      {suffix ? <span style={{ fontSize: 13, color: ENERGY_TEXT_SECONDARY, marginLeft: 8 }}>{suffix}</span> : null}
    </div>
  </EnergyOverviewCard>
);

export default EnergyKpiCard;
